import { FC, lazy, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { useAuth } from '../modules/auth'
import { isValidRole, RoleNameEnum } from '../core/utils/util'

///Acount
const PersonelPageWrappper = lazy(() => import('../pages/personel/Personel.page'))
const ConferenceRoomPage = lazy(() => import('../pages/ConferenceRoom/ConferenceRoom.page'))


////CardTable
const CardTablePage = lazy(() => import('../pages/CardTable/getAll.page'))
const DabirHomePage = lazy(() => import('../pages/CardTable/DabirHome.page'));
const MyWorkPage = lazy(() => import('../pages/CardTable/MyWork.page'));
const WaitingListPage = lazy(() => import('../pages/CardTable/WaitingList.page'));
const ArchiveListPage = lazy(() => import('../pages/CardTable/ArchiveList.page'));
const CardtableDetailPage = lazy(() => import('../pages/CardTable/Detail/Detail.page'));
const AllRequestPage = lazy(() => import('../pages/AllRequest/getAll.page'));
const AllSupervisionPage = lazy(() => import('../pages/AllSupervision/getAll.page'));
////Supervision
const SupervisionPage = lazy(() => import('../pages/Supervision/getAll.page'))
const SupervisionDabirHomePage = lazy(() => import('../pages/Supervision/DabirHome.page'));
const SupervisionMyWorkPage = lazy(() => import('../pages/Supervision/MyWork.page'));
const SupervisionWaitingListPage = lazy(() => import('../pages/Supervision/WaitingList.page'));
const SupervisionArchiveListPage = lazy(() => import('../pages/Supervision/ArchiveList.page'));
const SupervisionDetailPage = lazy(() => import('../pages/Supervision/Detail/Detail.page'));

////Request
const RequestFormPage = lazy(() => import('../pages/RequestForm/RequestForm'))

////UserDetail
const UserDetailPage = lazy(() => import('../pages/UserDetail/UserDetailPage'))

////Setting
const SettingPage = lazy(() => import('../pages/Setting/Setting.page'))

////ChatPage
const ChatPagePage = lazy(() => import('../pages/Tickets/ChatPage'))

////TicketDetailsPage
const TicketDetailsPage = lazy(() => import('../pages/TicketDetails/TicketDetailsPage'))

////Plans
const PlansPage = lazy(() => import('../pages/Plans/Plans'))

////Letter
const LetterPage = lazy(() => import('../pages/Letter/LetterPage'))


////Users
const UserListPage = lazy(() => import('../pages/users/UserList.page'))

////Wrote
const WroteListPage = lazy(() => import('../pages/Wrote/WrotePage'))

////Faq
const FaqPage = lazy(() => import('../pages/Faq/Faq.page'))

////Survey
const SurveyCategoryPage = lazy(() => import('../pages/survey/SurveyCategory/SurveyCategory.page'))
const SurveryPage = lazy(() => import('../pages/survey/Survery/Survery.pgae'))

//EditProfilePage
const EditProfilePage = lazy(() => import('../pages/EditProfile/EditProfile'))

////SupportVideo
const SupportVideoPage = lazy(() => import('../pages/SupportVideo/SupportVideo.page'))

/// ReportNavigate
const ReportNavigatePage = lazy(() => import('../pages/ReportNavigate/ReportNavigate'))

/// ReportsPage
const ReportsPage = lazy(() => import('../pages/Reports/ReportsPage'))

/// ArchivedDocument
const ArchivedDocumentPage = lazy(() => import('../pages/ArchivedDocument/ArchivedDocument'))

////NotificationPage
const NotificationPage = lazy(() => import('../pages/NotificationPage/NotificationPage'))


////ComplateRequestPage
const ComplateRequestPage = lazy(() => import('../pages/ComplateRequest/ComplateRequest'))

////ContractPreviewPage
const ContractPreviewPage = lazy(() => import('../pages/ContractPreview/ContractPreview'));

////Transaction
const TransactionPage = lazy(() => import('../pages/Transaction/Transaction/Transaction.page'));

////LetterManagement
const LetterManagementPage = lazy(() => import('../pages/LetterManagement/LetterManagement'));

////LetterDetail
const LetterDetailPage = lazy(() => import('../pages/LetterDetail/LetterDetail'));

////CustomText
const CustomTextPage = lazy(() => import('../pages/CustomText/CustomText.page'));
////WroteLetter
const WroteLetterPage = lazy(() => import('../pages/WroteLetter/WrotePage'));

const PrivateRoutes = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const { userInfo } = useAuth()
  const restrictedRoutesForBoard = [
    '/request-form',
    '/letter',
    '/support-video',
    '/archived-document',
    '/plans',
    '/setting-managment',
    '/tickets',
    '/ticket/',
    '/survey-category',
    '/survey-list/',
    '/edit-profile',
    '/personel-list',
    '/complate-request/',
    '/contract-preview/',
    "getall-cardtable-list",
    "cardtable-dabir-list",
    "cardtable-mywork-list",
    "cardtable-waiting-list",
    "cardtable-archive-list",
  ];

  useEffect(() => {
    if (userInfo && isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board)) {
      const pathname = location.pathname;

      const isRestricted = restrictedRoutesForBoard.some((route) =>
        pathname.startsWith(route)
      );

      if (isRestricted) {
        navigate('/dashboard');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, location, navigate]);

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='/request-form'
          element={
            <SuspensedView>
              <RequestFormPage />
            </SuspensedView>
          }
        />
        <Route
          path='/all-transaction'
          element={
            <SuspensedView>
              <TransactionPage />
            </SuspensedView>
          }
        />
        <Route
          path='/edit-profile'
          element={
            <SuspensedView>
              <EditProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='/personel-list'
          element={
            <SuspensedView>
              <PersonelPageWrappper />
            </SuspensedView>
          }
        />
        <Route
          path='/complate-request/:requestId'
          element={
            <SuspensedView>
              <ComplateRequestPage />
            </SuspensedView>
          }
        />
        <Route
          path='/contract-preview/:requestId'
          element={
            <SuspensedView>
              <ContractPreviewPage />
            </SuspensedView>
          }
        />
        <Route
          path='/support-video'
          element={
            <SuspensedView>
              <SupportVideoPage />
            </SuspensedView>
          }
        />
        <Route
          path='/archived-document'
          element={
            <SuspensedView>
              <ArchivedDocumentPage />
            </SuspensedView>
          }
        />
        <Route
          path='/conference-room'
          element={
            <SuspensedView>
              <ConferenceRoomPage />
            </SuspensedView>
          }
        />
        <Route
          path='/getall-cardtable-list/:statusId'
          element={
            <SuspensedView>
              <CardTablePage />
            </SuspensedView>
          }
        />
        <Route
          path='/cardtable-dabir-list'
          element={
            <SuspensedView>
              <DabirHomePage />
            </SuspensedView>
          }
        />
        <Route
          path='/cardtable-mywork-list'
          element={
            <SuspensedView>
              <MyWorkPage />
            </SuspensedView>
          }
        />
        <Route
          path='/cardtable-waiting-list'
          element={
            <SuspensedView>
              <WaitingListPage />
            </SuspensedView>
          }
        />
        <Route
          path='/cardtable-archive-list'
          element={
            <SuspensedView>
              <ArchiveListPage />
            </SuspensedView>
          }
        />
        <Route
          path='/cardtable-detail/:id'
          element={
            <SuspensedView>
              <CardtableDetailPage />
            </SuspensedView>
          }
        />

        {/* //// Supervision */}
        <Route
          path='/getall-supervision-list/:statusId'
          element={
            <SuspensedView>
              <SupervisionPage />
            </SuspensedView>
          }
        />
        <Route
          path='/supervision-dabir-list'
          element={
            <SuspensedView>
              <SupervisionDabirHomePage />
            </SuspensedView>
          }
        />
        <Route
          path='/supervision-mywork-list'
          element={
            <SuspensedView>
              <SupervisionMyWorkPage />
            </SuspensedView>
          }
        />
        <Route
          path='/supervision-waiting-list'
          element={
            <SuspensedView>
              <SupervisionWaitingListPage />
            </SuspensedView>
          }
        />
        <Route
          path='/supervision-archive-list'
          element={
            <SuspensedView>
              <SupervisionArchiveListPage />
            </SuspensedView>
          }
        />
        <Route
          path='/supervision-detail/:id'
          element={
            <SuspensedView>
              <SupervisionDetailPage />
            </SuspensedView>
          }
        />
        <Route
          path='/reports-navigate'
          element={
            <SuspensedView>
              <ReportNavigatePage />
            </SuspensedView>
          }
        />
        <Route
          path='/reports-navigate/:type'
          element={
            <SuspensedView>
              <ReportsPage />
            </SuspensedView>
          }
        />
        <Route
          path='/user-detail/*'
          element={
            <SuspensedView>
              <UserDetailPage />
            </SuspensedView>
          }
        />
        <Route
          path='/setting-managment'
          element={
            <SuspensedView>
              <SettingPage />
            </SuspensedView>
          }
        />
        <Route
          path='/tickets'
          element={
            <SuspensedView>
              <ChatPagePage />
            </SuspensedView>
          }
        />
        <Route
          path='/ticket/:id'
          element={
            <SuspensedView>
              <TicketDetailsPage />
            </SuspensedView>
          }
        />
        <Route
          path='/plans'
          element={
            <SuspensedView>
              <PlansPage />
            </SuspensedView>
          }
        />
        <Route
          path='/letter'
          element={
            <SuspensedView>
              <LetterPage />
            </SuspensedView>
          }
        />
        <Route
          path='/notifications'
          element={
            <SuspensedView>
              <NotificationPage />
            </SuspensedView>
          }
        />
        <Route
          path='/faq'
          element={
            <SuspensedView>
              <FaqPage />
            </SuspensedView>
          }
        />
        <Route
          path='/survey-category'
          element={
            <SuspensedView>
              <SurveyCategoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='/survey-list/:categoryId'
          element={
            <SuspensedView>
              <SurveryPage />
            </SuspensedView>
          }
        />
        <Route
          path='/user-list'
          element={
            <SuspensedView>
              <UserListPage />
            </SuspensedView>
          }
        />
        <Route
          path='/wrote'
          element={
            <SuspensedView>
              <WroteListPage />
            </SuspensedView>
          }
        />
        <Route
          path='/trans-letter'
          element={
            <SuspensedView>
              <WroteLetterPage />
            </SuspensedView>
          }
        />

        <Route
          path='/management-letter'
          element={
            <SuspensedView>
              <LetterManagementPage />
            </SuspensedView>
          }
        />
        <Route
          path='/all-request/:statusId'
          element={
            <SuspensedView>
              <AllRequestPage />
            </SuspensedView>
          }
        />
        <Route
          path='/all-supervision/:statusId'
          element={
            <SuspensedView>
              <AllSupervisionPage />
            </SuspensedView>
          }
        />
        <Route
          path='/detailletter/:letterId'
          element={
            <SuspensedView>
              <LetterDetailPage />
            </SuspensedView>
          }
        />
        <Route
          path='/custom-text'
          element={
            <SuspensedView>
              <CustomTextPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      {/* <Route
        path='/pdfexport'
        element={
          <SuspensedView>
            <PdfExportPage />
          </SuspensedView>
        }
      /> */}
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
